import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export const Field = ({ label, hint, className, children }) => (
  <div className={cn("space-y-2", className)}>
    <Label className="text-xs font-semibold uppercase tracking-[0.12em] text-zinc-400">{label}</Label>
    {children}
    {hint && <p className="text-[11px] text-zinc-600">{hint}</p>}
  </div>
);

export const ChipSelect = ({ options, value, onChange, multi, testid }) => {
  const selected = multi ? value || [] : [value];
  const toggle = (v) => {
    if (multi) onChange(selected.includes(v) ? selected.filter((x) => x !== v) : [...selected, v]);
    else onChange(value === v ? "" : v);
  };
  return (
    <div className="flex flex-wrap gap-2" data-testid={testid}>
      {options.map((o) => {
        const on = selected.includes(o.value);
        return (
          <button key={o.value} type="button" onClick={() => toggle(o.value)} data-testid={`${testid}-${o.value}`}
            className={cn("rounded-full border px-3.5 py-1.5 text-xs font-medium transition-colors",
              on ? "border-[#D4AF37] bg-[#D4AF37] text-black" : "border-[#3F3F46] bg-[#09090B] text-zinc-400 hover:border-[#D4AF37]/60 hover:text-zinc-200")}>
            {o.label}
          </button>
        );
      })}
    </div>
  );
};

export const MoneyInput = ({ value, onChange, testid, placeholder }) => (
  <div className="relative">
    <span className="absolute left-3 top-1/2 -translate-y-1/2 font-mono text-sm text-zinc-500">$</span>
    <Input inputMode="numeric" value={value == null || value === "" ? "" : Number(value).toLocaleString("en-US")} placeholder={placeholder}
      onChange={(e) => { const n = e.target.value.replace(/[^\d]/g, ""); onChange(n ? Number(n) : null); }}
      className="bg-[#09090B] pl-7 font-mono" data-testid={testid} />
  </div>
);
